import { render, staticRenderFns } from "./ExamineCreateView.vue?vue&type=template&id=3ae5e679&scoped=true"
import script from "./ExamineCreateView.vue?vue&type=script&lang=js"
export * from "./ExamineCreateView.vue?vue&type=script&lang=js"
import style0 from "./ExamineCreateView.vue?vue&type=style&index=0&id=3ae5e679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5e679",
  null
  
)

export default component.exports